import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from 'reactstrap';
import { ModalButtonCancel } from '../../constant';

export const FormTransports = (props) => {

    const {
        toggle, loading, handleInputChange, validaciones, methodAction, name, abbreviation, code, button
    } = props;

    const {
        name_valid, abbreviation_valid, code_valid
    } = validaciones;

    return (
        <Form  role="form" onSubmit={methodAction}>
            <ModalBody>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className="col-form-label">Nombre del transporte <span style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="text"
                                name="name"
                                onChange={handleInputChange}
                                value={name}
                                autoComplete="off"
                                invalid={name_valid}
                                className="input-air-primary "

                            />
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label className="col-form-label">Abreviación <span style={{ color: "#0079C7" }}>*</span></Label>
                            <Input
                                type="text"
                                name="abbreviation"
                                onChange={handleInputChange}
                                value={abbreviation}
                                autoComplete="off"
                                invalid={abbreviation_valid}
                                className="input-air-primary "

                            />
                            <FormFeedback>La abreviación debe tener más de un caracter</FormFeedback>
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label className="col-form-label">Código <span style={{ color: "0079C7" }}>*</span></Label>
                            <Input
                                type="text"
                                name="code"
                                onChange={handleInputChange}
                                value={code}
                                autoComplete="off"
                                invalid={code_valid}
                                className="input-air-primary "

                            />
                            <FormFeedback>El código debe tener más de un caracter</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button outline color="primary" type="submit" size="sm" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {button}
                </Button>
                <Button size="sm" className="btn-air-light" outline color='danger' type="button" onClick={toggle}>
                    {ModalButtonCancel}
                </Button>
            </ModalFooter>
        </Form>
    )
}
